import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import { Observable } from 'rxjs/Observable';

import { Patch, PayerInfo, Payment } from '../../external_api/model/paypal';
import { ExternalAPI } from '../../external_api/service/external-api.service';
import { TscAPI } from '../../tscapi/service/tscapi.service';
import { Cookie } from '../../utils/cookie';
import { TmAccount, TmAddress } from '../model/account';
import { TmCart } from '../model/cart';
import { TmErrorInfo } from '../model/error';
import { TmAccountRequest } from '../model/request/account-request';
import {
    TmGiftCardRequest,
    TmMergeCartRequest,
    TmPaymentRequest,
    TmSelectShippingAddressRequest,
    TmShipMethodRequest,
} from '../model/request/account_cart-request';
import { TmCartInstallmentRequest } from '../model/request/cart-request';

import { Account } from './account.service';
import { ApiBase } from './apibase.service';


export class AccountCartBase extends ApiBase {
    private cookie = new Cookie();
    protected accountBaseUrl =
        this.cookie.UserAccessToken != undefined && this.cookie.UserAccessToken.Edp != undefined
            ? this.baseUrl + '/accounts/' + this.cookie.UserAccessToken.Edp
            : this.baseUrl;

    protected acctCartBaseUrl = this.accountBaseUrl + '/cart';

    constructor(protected http: Http) {
        super(http);
    }
}(AccountCartBase as any).ctorParameters = function () { return [ { type: Http } ]; }


export class AccountCart extends AccountCartBase {
    constructor(protected http: Http) {
        super(http);
    }

    /** @description Get most recent persisted cart for given account
     *   @return {TmCart}
     */

    get(): Observable<TmCart> {
        const cookie = new Cookie();
        if (cookie.UserAccessToken === undefined) {
            this.handleAuthorizationFailure();
        }
        return this.http
            .get(this.acctCartBaseUrl, { headers: this.userTokenJsonTypeHeader })
            .map((resp) => resp.json() as TmCart)
            .catch((e) => {
                if (e.status === 401) {
                    this.handleAuthorizationFailure();
                } else {
                    console.log('Cart not found');
                    return Observable.of(null);
                }
            });
    }

    /** @description Merge cart with given cartGuid to account's persisted cart.
     *   @return {TmCart}
     */
    put(cartReq: TmMergeCartRequest): Observable<TmCart> {
        const url = this.accountBaseUrl + '/cart';
        if (new Cookie().UserAccessToken === undefined) {
            this.handleAuthorizationFailure();
        }
        return this.http
            .put(url, cartReq, { headers: this.userTokenJsonTypeHeader })
            .map((resp) => resp.json() as TmCart)
            .catch(this.handleError);
    }
}(AccountCart as any).ctorParameters = function () { return [ { type: Http } ]; }


export class AccountCart_Shipmethod extends AccountCartBase {
    constructor(protected http: Http) {
        super(http);
    }

    /** @description Update shipmethod of given account's persisted cart.
     *   @return {TmCart}
     */
    put(shipRequest: TmShipMethodRequest): Observable<TmCart> {
        const url = this.acctCartBaseUrl + '/shipmethod';
        if (new Cookie().UserAccessToken === undefined) {
            this.handleAuthorizationFailure();
        }
        return this.http
            .put(url, shipRequest, { headers: this.userTokenJsonTypeHeader })
            .map((resp) => resp.json() as TmCart);
    }
}(AccountCart_Shipmethod as any).ctorParameters = function () { return [ { type: Http } ]; }


export class AccountCart_Payment extends AccountCartBase {
    constructor(protected http: Http) {
        super(http);
    }

    /** @description Update payment details of given account's persisted cart.
     *   @return {TmCart}
     */
    put(payRequest: TmPaymentRequest): Observable<TmCart> {
        const url = this.acctCartBaseUrl + '/payment';
        if (new Cookie().UserAccessToken === undefined) {
            this.handleAuthorizationFailure();
        }
        return this.http
            .put(url, payRequest, { headers: this.userTokenJsonTypeHeader })
            .map((resp) => resp.json() as TmCart);
    }

    /** @description Remove creditcard associated with given account's persisted cart.
     *   @return {TmCart}
     */
    delete(creditCardId): Observable<TmCart> {
        const url = `${this.acctCartBaseUrl}/payment/${creditCardId}`;
        if (new Cookie().UserAccessToken === undefined) {
            this.handleAuthorizationFailure();
        }
        return this.http.delete(url, { headers: this.userTokenJsonTypeHeader }).map((resp) => resp.json() as TmCart);
    }
}(AccountCart_Payment as any).ctorParameters = function () { return [ { type: Http } ]; }


export class AccountCart_ShippingAddress extends AccountCartBase {
    constructor(protected http: Http) {
        super(http);
    }

    /** @description Update shippingaddress of given account's persisted cart.
     *   @return {TmCart}
     */
    put(addressReq: TmSelectShippingAddressRequest): Observable<TmCart> {
        const url = this.acctCartBaseUrl + '/shippingaddress';
        if (new Cookie().UserAccessToken === undefined) {
            this.handleAuthorizationFailure();
        }
        return this.http
            .put(url, addressReq, { headers: this.userTokenJsonTypeHeader })
            .map((resp) => resp.json() as TmCart);
    }

    /** @description Update shippingaddress of given account's persisted cart.
     *   @return {TmCart}
     */
    post(address: TmAddress): Observable<TmCart> {
        const url = this.acctCartBaseUrl + '/shippingaddress';
        if (new Cookie().UserAccessToken === undefined) {
            this.handleAuthorizationFailure();
        }
        return this.http
            .post(url, address, { headers: this.userTokenJsonTypeHeader })
            .map((resp) => resp.json() as TmCart);
    }
}(AccountCart_ShippingAddress as any).ctorParameters = function () { return [ { type: Http } ]; }


export class AccountCart_GiftCard extends AccountCartBase {
    protected acctCartGiftCardBaseUrl = this.acctCartBaseUrl + '/giftcards';

    constructor(protected http: Http) {
        super(http);
    }

    /** @description Apply giftcard to given account's persisted cart.
     *   @return {TmCart}
     */
    post(giftCardReq: TmGiftCardRequest): Observable<TmCart> {
        if (new Cookie().UserAccessToken === undefined) {
            this.handleAuthorizationFailure();
        }
        return this.http
            .post(this.acctCartGiftCardBaseUrl, giftCardReq, { headers: this.userTokenJsonTypeHeader })
            .map((resp) => resp.json() as TmCart)
            .catch(this.handleError);
    }

    /** @description Delete giftcard from given account's persisted cart
     *   @return {TmCart}
     */
    delete(giftCardId: number): Observable<TmCart> {
        const url = `${this.acctCartGiftCardBaseUrl}/${giftCardId}`;
        if (new Cookie().UserAccessToken === undefined) {
            this.handleAuthorizationFailure();
        }
        return this.http
            .delete(url, { headers: this.userTokenJsonTypeHeader })
            .map((resp) => resp.json() as TmCart)
            .catch(this.handleError);
    }
}(AccountCart_GiftCard as any).ctorParameters = function () { return [ { type: Http } ]; }


export class Account_PaypalReviewOrder extends AccountCartBase {
    /** @description for signedIn user, get paypal payment details, update cart and review order
     * @return {TmCart}
     */
    paypalReviewOrder(): Observable<TmCart> {
        const cookie = new Cookie();
        const paypalSvc = new ExternalAPI(this.http);
        return paypalSvc.paypal_Payment
            .get()
            .map((paymentRes) => paymentRes as Payment)
            .flatMap((paymentRes) => {
                //capture paypal info
                let payerPhone = '';
                if (paymentRes.payer != null && paymentRes.payer.payer_info != null) {
                    cookie.PaypalPayerEmail = paymentRes.payer.payer_info.email;
                    cookie.PaypalPayerId = paymentRes.payer.payer_info.payer_id;
                    payerPhone = paymentRes.payer.payer_info.phone;
                }

                //update payment card type
                const paymentReq = new TmPaymentRequest();
                paymentReq.CardType = 'PY';
                return new AccountCart_Payment(this.http)
                    .put(paymentReq)
                    .map((acctCartResp) => acctCartResp as TmCart)
                    .flatMap((resp) => {
                        //update shipping address
                        const cart = resp as TmCart;
                        if (cart.Buyer != null && cart.ShippingAddress == null) {
                            const shipAddress = cart.Buyer.ShippingAddresses;

                            let defaultShipAddress = cart.Buyer.BillingAddress;
                            if (
                                cart.Buyer.ShippingAddresses != null &&
                                cart.Buyer.ShippingAddresses.findIndex((x) => x.IsDefault == true) > 0
                            ) {
                                defaultShipAddress = cart.Buyer.ShippingAddresses.find((x) => x.IsDefault == true);
                            }
                            const cartShipAddressReq = new TmSelectShippingAddressRequest();
                            cartShipAddressReq.ShippingAddressId = defaultShipAddress.Id;

                            return new AccountCart_ShippingAddress(this.http)
                                .put(cartShipAddressReq)
                                .map((cartResp) => cartResp as TmCart)
                                .flatMap((cartReview) => {
                                    const easypayReq = new TmCartInstallmentRequest();
                                    easypayReq.NoOfInstallments = 1;
                                    return new TscAPI(this.http).carts_Installment
                                        .put(easypayReq)
                                        .map((cartResp) => cartResp as TmCart)
                                        .flatMap((cartResp) => {
                                            return new TscAPI(this.http).orderreview
                                                .get()
                                                .map((resp) => resp as TmCart);
                                        });
                                });
                        } else {
                            //reset easypay to 1
                            const easypayReq = new TmCartInstallmentRequest();
                            easypayReq.NoOfInstallments = 1;
                            return new TscAPI(this.http).carts_Installment
                                .put(easypayReq)
                                .map((cartResp) => cartResp as TmCart)
                                .flatMap((cartResp) => {
                                    return new TscAPI(this.http).orderreview.get().map((resp) => resp as TmCart);
                                });
                        }
                    });
            });
    }

    paypalReviewGuestOrder(): Observable<TmCart> {
        const cookie = new Cookie();
        const paypalSvc = new ExternalAPI(this.http);
        return paypalSvc.paypal_Payment
            .get()
            .map((paymentRes) => paymentRes as Payment)
            .flatMap((paymentRes) => {
                //capture paypal info
                let payerInfo: PayerInfo;
                if (paymentRes.payer != null && paymentRes.payer.payer_info != null) {
                    payerInfo = paymentRes.payer.payer_info;
                    cookie.PaypalPayerEmail = paymentRes.payer.payer_info.email;
                    cookie.PaypalPayerId = paymentRes.payer.payer_info.payer_id;
                }

                //create guest account
                const info: TmAccountRequest = this.buildGuestAccountRequest(payerInfo);

                return new Account(this.http)
                    .post(info)
                    .map((acctResp) => acctResp as TmAccount)
                    .flatMap((resp) => {
                        cookie.GuestAccountLogin = 'true';
                        const cartReq: TmMergeCartRequest = new TmMergeCartRequest();
                        cartReq.CartGuid = cookie.CartGuid;

                        return new AccountCart(this.http)
                            .put(cartReq)
                            .map((resp) => resp as TmCart)
                            .flatMap((resp) => {
                                //update payment card type
                                const paymentReq = new TmPaymentRequest();
                                paymentReq.CardType = 'PY';
                                return new AccountCart_Payment(this.http)
                                    .put(paymentReq)
                                    .map((acctCartResp) => acctCartResp as TmCart)
                                    .flatMap((resp) => {
                                        //update shipping address
                                        const cart = resp as TmCart;
                                        if (cart.Buyer != null && cart.ShippingAddress == null) {
                                            const shipAddress = cart.Buyer.ShippingAddresses;

                                            let defaultShipAddress = cart.Buyer.BillingAddress;
                                            if (
                                                cart.Buyer.ShippingAddresses != null &&
                                                cart.Buyer.ShippingAddresses.findIndex((x) => x.IsDefault == true) > 0
                                            ) {
                                                defaultShipAddress = cart.Buyer.ShippingAddresses.find(
                                                    (x) => x.IsDefault == true,
                                                );
                                            }
                                            const cartShipAddressReq = new TmSelectShippingAddressRequest();
                                            cartShipAddressReq.ShippingAddressId = defaultShipAddress.Id;

                                            return new AccountCart_ShippingAddress(this.http)
                                                .put(cartShipAddressReq)
                                                .map((cartResp) => cartResp as TmCart)
                                                .flatMap((cartReview) => {
                                                    const easypayReq = new TmCartInstallmentRequest();
                                                    easypayReq.NoOfInstallments = 1;
                                                    return new TscAPI(this.http).carts_Installment
                                                        .put(easypayReq)
                                                        .map((cartResp) => cartResp as TmCart)
                                                        .flatMap((cartResp) => {
                                                            return new TscAPI(this.http).orderreview
                                                                .get()
                                                                .map((resp) => resp as TmCart);
                                                        });
                                                });
                                        } else {
                                            //reset easypay to 1
                                            const easypayReq = new TmCartInstallmentRequest();
                                            easypayReq.NoOfInstallments = 1;
                                            return new TscAPI(this.http).carts_Installment
                                                .put(easypayReq)
                                                .map((cartResp) => cartResp as TmCart)
                                                .flatMap((cartResp) => {
                                                    return new TscAPI(this.http).orderreview
                                                        .get()
                                                        .map((resp) => resp as TmCart);
                                                });
                                        }
                                    });
                            });
                    })
                    .catch((accountResp) => {
                        return Observable.throw(accountResp as TmErrorInfo);
                    });
            });
    }

    //approve payment and update payment method
    paypalApprovePayment(): Observable<TmCart> {
        const cookie = new Cookie();
        const paypalSvc = new ExternalAPI(this.http);
        return paypalSvc.paypal_Payment
            .get()
            .map((paymentRes) => paymentRes as Payment)
            .flatMap((paymentRes) => {
                //capture paypal info
                if (paymentRes.payer != null && paymentRes.payer.payer_info != null) {
                    cookie.PaypalPayerEmail = paymentRes.payer.payer_info.email;
                    cookie.PaypalPayerId = paymentRes.payer.payer_info.payer_id;
                }

                //update payment card type
                const paymentReq = new TmPaymentRequest();
                paymentReq.CardType = 'PY';
                return new AccountCart_Payment(this.http).put(paymentReq).map((acctCartResp) => acctCartResp as TmCart);
            });
    }

    //update paypal payment
    paypalUpdatePayment(paymentUpdates: Patch[]): Observable<TmCart> {
        const cookie = new Cookie();
        const paypalSvc = new ExternalAPI(this.http);

        return paypalSvc.paypal_Payment
            .patch(paymentUpdates)
            .map((paymentRes) => paymentRes)
            .flatMap((paymentRes) => {
                const easypayReq = new TmCartInstallmentRequest();
                easypayReq.NoOfInstallments = 1;

                return new TscAPI(this.http).carts_Installment
                    .put(easypayReq)
                    .map((cartResp) => cartResp as TmCart)
                    .flatMap((cartReview) => {
                        return new TscAPI(this.http).orderreview.get().map((resp) => resp as TmCart);
                    });
            });
    }

    private buildGuestAccountRequest(payerInfo: PayerInfo) {
        const info = new TmAccountRequest();
        info.IsGuest = true;
        info.IsPhoneCustomer = false;

        info.Email = payerInfo.email;
        if (payerInfo.phone != '') {
            info.Phone = payerInfo.phone.replace(/-/g, '');
        }
        info.Phone = payerInfo.phone;
        info.Subscribe = false;

        const shipAddress = payerInfo.shipping_address;
        if (shipAddress != null) {
            info.FirstName = shipAddress.recipient_name.split(' ')[0];
            info.LastName = shipAddress.recipient_name.split(' ')[1];
            info.Address1 = shipAddress.line1;
            info.Address2 = shipAddress.line2;
            info.PostalCode = shipAddress.postal_code.replace(' ', '');
            info.City = shipAddress.city;
            info.Province = this.getProvinceCode(shipAddress.state);
            info.IsPOBox = false;
        }
        return info;
    }
}



// WEBPACK FOOTER //
// C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/ngc-webpack??ref--0-1!C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/angular2-template-loader!../tscapi/service/account-cart.service.ts